import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentUrl } from '@app/entities/models/ptrab/documents/document-url.model';
import { Document } from '@app/entities/models/ptrab/documents/document.model';

export interface DocumentsRepository {
  getDocuments(): Observable<Document[]>;
  getDocumentUrlById(documentId: string): Observable<DocumentUrl>;
  getOnBoardingDocumentUrlById(documentId: string): Observable<DocumentUrl>;
  getOnBoardingDocument(): Observable<Document[]>;
}

export const DOCUMENTS_REPOSITORY = new InjectionToken<DocumentsRepository>('DOCUMENTS_REPOSITORY');
